import React from 'react'

const mainForm = props =>{
    return(
          
        <section className="form-section">
             <div className="ms-width">
                <div className="form-content">
                    {props.children}
                </div>
             </div>
        </section>     
    )
}

export default mainForm;